import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FaDownload } from "react-icons/fa";

import { useBoletos } from "@/hooks";
import Paginator, { Loading } from "@/components/Paginator";
import { Select } from "@/components/Form";

import {
  BoletoListItem,
  ActionButton,
  StatusBadge,
  Label,
  Div
} from "./styles";

export default function Boletos() {
  const { data: user } = useSelector(state => state.auth);
  const [boletos, setBoletos] = useState([]);
  const [query, setQuery] = useState({ filters: "todos" });
  const [Default, setDefault] = useState("todos");
  const [paginator, setPaginator] = useState(null);
  const [loadingBoletos, setLoadingBoletos] = useState(false);

  const Options = [
    { id: "todos", title: "Todos os boletos" },
    { id: "OPEN", title: "Em aberto" },
    { id: "PAID", title: "Pagos" },
    { id: "LATE", title: "Vencidos" },
    // { id: "CANCELED", title: "Cancelados" },
  ];

  function handleOnFetchComplete(data) {
    setBoletos(data.data);
    setPaginator(data.paginator);
  }

  function handleChangeFilter(e) {
    const filterValue = e.target.value;
    if (filterValue === "todos") {
      setQuery({});
    } else {
      setQuery({ status: filterValue });
    }
  }

  function formatCurrency(value) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value / 100);
  }

  function formatDate(dateString) {
    return new Date(dateString).toLocaleDateString('pt-BR');
  }

  function getStatusColor(status) {
    switch (status) {
      case 'OPEN': return '#f39c12';
      case 'PAID': return '#27ae60';
      case 'LATE': return '#e74c3c';
      case 'CANCELED': return '#95a5a6';
      default: return '#95a5a6';
    }
  }

  function getStatusText(status) {
    switch (status) {
      case 'OPEN': return 'Em aberto';
      case 'PAID': return 'Pago';
      case 'LATE': return 'Vencido';
      case 'CANCELED': return 'Cancelado';
      default: return status;
    }
  }

  function handleDownloadBoleto(boleto) {
    if (boleto.bank_slip_url) {
      window.open(boleto.bank_slip_url, '_blank');
    }
  }

  function renderBoletos() {
    if (paginator && paginator.total === 0) {
      return <Label>Você não possui nenhum boleto</Label>;
    }

    if (boletos.length > 0) {
      return boletos.map(boleto => (
        <BoletoListItem key={boleto.id}>
          <div className="coluna coluna-nome">
            <h4>Boleto<br />#{boleto.code}</h4>
          </div>
          <div className="coluna coluna-valor">
            <h4>Valor</h4>
            <h5>{formatCurrency(boleto.total_amount)}</h5>
          </div>
          <div className="coluna coluna-vencimento">
            <h4>Vencimento</h4>
            <h5>{formatDate(boleto.due_date)}</h5>
          </div>
          <div className="coluna coluna-status">
            <h4>Status</h4>
            <StatusBadge color={getStatusColor(boleto.status)}>
              {getStatusText(boleto.status)}
            </StatusBadge>
          </div>
          <div className="coluna coluna-actions">
            {boleto.bank_slip_url && boleto.status !== 'CANCELED' && boleto.status !== 'PAID' && (
              <ActionButton onClick={() => handleDownloadBoleto(boleto)}>
                <FaDownload color="#271946" size={14} />
                <span>Baixar</span>
              </ActionButton>
            )}
          </div>
        </BoletoListItem>
      ));
    }

    return <></>;
  }

  return (
    <Loading loading={loadingBoletos}>
      <Div>
        <Select
          name="filtro-boletos"
          label="Filtro dos Boletos"
          options={Options}
          onChange={e => {
            handleChangeFilter(e);
            setDefault(e.target.value);
          }}
          value={Default}
        />
        <div className="colunasub">
          <h3>{boletos.length}</h3>
        </div>
      </Div>
      <span>
        <br />
      </span>
      {renderBoletos()}
      <Paginator
        endpoint={`empresas/${user.empresa.id}/boletos`}
        query={query}
        onFetchComplete={handleOnFetchComplete}
        onLoading={loading => setLoadingBoletos(loading)}
      />
    </Loading>
  );
}
